import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '@shared/services/shared.service';
import { IHousehold } from 'app/models/household/household';
import { HouseholdService } from 'app/services/household-service';
import { HousingUnitService } from 'app/services/housingunit-service';

/*
 * Merge Voucher Dialog
 */
@Component({
  selector: 'dialog-merge-households',
  templateUrl: 'merge-households.html',
  styleUrls: ['./merge-households.scss']
})
export class DialogMergeHouseholdsComponent implements OnInit {
  loading: boolean = false;
  merging: boolean = false;
  displayedColumns: string[] = ['action', 'id', 'contactName', 'address1', 'city', 'zip', 'county'];
  selectedId: number = 0;
  items: IHousehold[] = [];
  type: string = '';
  

  constructor(public householdService: HouseholdService,
    public housingUnitService: HousingUnitService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<DialogMergeHouseholdsComponent>) {
      this.items = data.items;
      this.type = data.type;
  }

  ngOnInit(): void {     
    if (this.type == this.householdService.householdText) {
      this.displayedColumns = ['action', 'id', 'contactName', 'address1', 'city', 'zip', 'county', 'personsInHousehold', 'comments'];
    }
    else {
      this.displayedColumns = ['action', 'id', 'contactName', 'address1', 'city', 'zip', 'county'];
    }
  }

  onChangeSelectedId(id: number) {
    this.selectedId = id;
  }

  merge() {
    this.sharedService.openConfirm("Are you sure you want to perform this merge?");

    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.merging = true;
        let notSelected = this.items.filter(w => w.id !== this.selectedId).map(m => m.id);

        if(this.type == this.householdService.householdText) {
          this.householdService.mergeHousehold(this.selectedId, notSelected).subscribe(result => {
            this.merging = false;
            this.toastr.success('Merge successful');
            this.dialogRef.close();
            this.merging = false;
          }, 
          error => {
            this.merging = false;
          });

        }
        else {          
          this.housingUnitService.mergeHousingUnit(this.selectedId, notSelected).subscribe(result => {
            this.merging = false;
            this.toastr.success('Merge successful');
            this.dialogRef.close();
            this.merging = false;
          }, 
          error => {
            this.merging = false;
        });
        }
      }
    });
  }
}